import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const StudentEngagementGauge = (props) => (
  <KpiChart
    title="Engagement"
    description="The number represents the average time that students have studied in the reference month. It only considers students who have studying time."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 3, 6, 9, 12]}
    stepSize={3}
    reverseColors={false}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

StudentEngagementGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

StudentEngagementGauge.propTypes = {
  onClickHistory: null,
};

export default StudentEngagementGauge;
